<fgb-page-header [pageTitle]="'earn.page.title'" [showBalance]="false" [backButtonLink]="'/'"></fgb-page-header>

<div class="container">
  <fgbcl-earn-points></fgbcl-earn-points>
</div>
